module.exports = __webpack_public_path__ + "img/failed.b9b72e78.svg";